import _ from 'lodash'
import T from 'i18n-react'
import { createSelector } from 'reselect'

export const entitiesSelector = state => state.entities

export const createSelectorWithPath = _.curry(
  (path, select, state) => select(_.get(state, path))
)

export const createSelectorWithEntity = _.curry((inputSelector, resultFunc) => {
  return createSelector(
    entitiesSelector,
    inputSelector,
    resultFunc
  )
})

export const elementsSelector = createSelector(
  entitiesSelector,
  (entities) => entities.elements
)

export const labelSelectorFunc = state => T.translate(state.label)
